const isMac = navigator.platform.toLowerCase().indexOf('mac') !== -1;

export default {
  PRIMARY_COMBINATION_KEY: isMac ? 'metaKey' : 'ctrlKey',
  TAB: 'TAB',
  ENTER: 'ENTER',
  SHIFT: 'SHIFT',
  CONTROL: 'CONTROL',
  ESCAPE: 'ESCAPE',
  SPACE: 'SPACE',
  ARROW_LEFT: 'ARROWLEFT',
  ARROW_UP: 'ARROWUP',
  ARROW_RIGHT: 'ARROWRIGHT',
  ARROW_DOWN: 'ARROWDOWN',
  INSERT: 'INSERT',
  SUPR: 'SUPR',
  BACKSPACE: 'BACKSPACE',
  A: 'A',
  B: 'B',
  C: 'C',
  D: 'D',
  E: 'E',
  F: 'F',
  G: 'G',
  H: 'H',
  I: 'I',
  J: 'J',
  K: 'K',
  L: 'L',
  M: 'M',
  N: 'N',
  Ñ: 'Ñ',
  O: 'O',
  P: 'P',
  Q: 'Q',
  R: 'R',
  S: 'S',
  T: 'T',
  U: 'U',
  V: 'V',
  W: 'W',
  X: 'X',
  Y: 'Y',
  Z: 'Z',
};
